import { MAP_COORDS_PRECISION } from '../constants/constants';

/**
 * Round number with the given precision (round half away from zero)
 * Example:
 *
 *     round(Math.PI, 4) === 3.1416
 *     round(1.005, 2) === 1.01
 *     round(-1.005, 2) === -1.01
 *
 * @param {number} n
 * @param {number} precision
 * @returns {number}
 */
export function round(n, precision = MAP_COORDS_PRECISION) {
  const q = 10 ** precision;
  return Math.round((n + Number.EPSILON * Math.sign(n)) * q) / q;
}

/**
 * Round in FP style
 *
 *     [Math.PI, Math.E].map(round.fp(2)) // [3.14, 2.72]
 *
 * @param {number} precision
 * @returns {(n: number) => number}
 */
round.fp =
  (precision = MAP_COORDS_PRECISION) =>
  (n) =>
    round(n, precision);
